import {
  GET_STYLE_LEDGER_REPORT_REQUEST,
  GET_STYLE_LEDGER_REPORT_SUCCESS,
  GET_STYLE_LEDGER_REPORT_ERROR,
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config";


export const getStyleLedger = (token, values) => (dispatch) => {
  
  dispatch({ type: GET_STYLE_LEDGER_REPORT_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/StyleLedger`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: { ...values },
  })
    .then((response) => {
      return dispatch({
        type: GET_STYLE_LEDGER_REPORT_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_STYLE_LEDGER_REPORT_ERROR,
        payload: [],
      });
      
      
      
      
      
      
      
      
      
      
    });
};
